/* tslint:disable */
/* eslint-disable */
/**
 * Appli métier
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: Yoda 1 & 2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from "../configuration"
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from "axios"
import globalAxios from "axios"
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
  replaceWithSerializableTypeIfNeeded
} from "../common"
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  type RequestArgs,
  BaseAPI,
  RequiredError,
  operationServerMap
} from "../base"
// @ts-ignore
import type { CodeLibelle } from "../model"
/**
 * SectorsResourceApi - axios parameter creator
 */
export const SectorsResourceApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Get project sector informations
     * @param {number} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProjectSector: async (
      projectId: number,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'projectId' is not null or undefined
      assertParamExists("getProjectSector", "projectId", projectId)
      const localVarPath = `/v2.0/sectors/project/{projectId}`.replace(
        "{projectId}",
        encodeURIComponent(String(projectId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication oauth2 required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @summary Get structure sector informations
     * @param {string} structureId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getStructureSector: async (
      structureId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'structureId' is not null or undefined
      assertParamExists("getStructureSector", "structureId", structureId)
      const localVarPath = `/v2.0/sectors/structure/{structureId}`.replace(
        "{structureId}",
        encodeURIComponent(String(structureId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication oauth2 required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @summary Update project sector
     * @param {number} projectId
     * @param {CodeLibelle} codeLibelle
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateProjectSector: async (
      projectId: number,
      codeLibelle: CodeLibelle,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'projectId' is not null or undefined
      assertParamExists("updateProjectSector", "projectId", projectId)
      // verify required parameter 'codeLibelle' is not null or undefined
      assertParamExists("updateProjectSector", "codeLibelle", codeLibelle)
      const localVarPath = `/v2.0/sectors/project/{projectId}`.replace(
        "{projectId}",
        encodeURIComponent(String(projectId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication oauth2 required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"
      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        codeLibelle,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @summary Update structure sector
     * @param {string} structureId
     * @param {number} projectId
     * @param {CodeLibelle} codeLibelle
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateStructureSector: async (
      structureId: string,
      projectId: number,
      codeLibelle: CodeLibelle,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'structureId' is not null or undefined
      assertParamExists("updateStructureSector", "structureId", structureId)
      // verify required parameter 'projectId' is not null or undefined
      assertParamExists("updateStructureSector", "projectId", projectId)
      // verify required parameter 'codeLibelle' is not null or undefined
      assertParamExists("updateStructureSector", "codeLibelle", codeLibelle)
      const localVarPath = `/v2.0/sectors/structure/{structureId}/project/{projectId}`
        .replace("{structureId}", encodeURIComponent(String(structureId)))
        .replace("{projectId}", encodeURIComponent(String(projectId)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "PUT", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication oauth2 required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

      localVarHeaderParameter["Content-Type"] = "application/json"
      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        codeLibelle,
        localVarRequestOptions,
        configuration
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * SectorsResourceApi - functional programming interface
 */
export const SectorsResourceApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = SectorsResourceApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @summary Get project sector informations
     * @param {number} projectId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getProjectSector(
      projectId: number,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CodeLibelle>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getProjectSector(projectId, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["SectorsResourceApi.getProjectSector"]?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Get structure sector informations
     * @param {string} structureId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getStructureSector(
      structureId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CodeLibelle>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getStructureSector(
        structureId,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["SectorsResourceApi.getStructureSector"]?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Update project sector
     * @param {number} projectId
     * @param {CodeLibelle} codeLibelle
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateProjectSector(
      projectId: number,
      codeLibelle: CodeLibelle,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CodeLibelle>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.updateProjectSector(
        projectId,
        codeLibelle,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["SectorsResourceApi.updateProjectSector"]?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Update structure sector
     * @param {string} structureId
     * @param {number} projectId
     * @param {CodeLibelle} codeLibelle
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async updateStructureSector(
      structureId: string,
      projectId: number,
      codeLibelle: CodeLibelle,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CodeLibelle>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.updateStructureSector(
        structureId,
        projectId,
        codeLibelle,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["SectorsResourceApi.updateStructureSector"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    }
  }
}

/**
 * SectorsResourceApi - factory interface
 */
export const SectorsResourceApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = SectorsResourceApiFp(configuration)
  return {
    /**
     *
     * @summary Get project sector informations
     * @param {SectorsResourceApiGetProjectSectorRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getProjectSector(
      requestParameters: SectorsResourceApiGetProjectSectorRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<CodeLibelle> {
      return localVarFp
        .getProjectSector(requestParameters.projectId, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @summary Get structure sector informations
     * @param {SectorsResourceApiGetStructureSectorRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getStructureSector(
      requestParameters: SectorsResourceApiGetStructureSectorRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<CodeLibelle> {
      return localVarFp
        .getStructureSector(requestParameters.structureId, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @summary Update project sector
     * @param {SectorsResourceApiUpdateProjectSectorRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateProjectSector(
      requestParameters: SectorsResourceApiUpdateProjectSectorRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<CodeLibelle> {
      return localVarFp
        .updateProjectSector(requestParameters.projectId, requestParameters.codeLibelle, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @summary Update structure sector
     * @param {SectorsResourceApiUpdateStructureSectorRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    updateStructureSector(
      requestParameters: SectorsResourceApiUpdateStructureSectorRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<CodeLibelle> {
      return localVarFp
        .updateStructureSector(
          requestParameters.structureId,
          requestParameters.projectId,
          requestParameters.codeLibelle,
          options
        )
        .then(request => request(axios, basePath))
    }
  }
}

/**
 * Request parameters for getProjectSector operation in SectorsResourceApi.
 */
export interface SectorsResourceApiGetProjectSectorRequest {
  readonly projectId: number
}

/**
 * Request parameters for getStructureSector operation in SectorsResourceApi.
 */
export interface SectorsResourceApiGetStructureSectorRequest {
  readonly structureId: string
}

/**
 * Request parameters for updateProjectSector operation in SectorsResourceApi.
 */
export interface SectorsResourceApiUpdateProjectSectorRequest {
  readonly projectId: number

  readonly codeLibelle: CodeLibelle
}

/**
 * Request parameters for updateStructureSector operation in SectorsResourceApi.
 */
export interface SectorsResourceApiUpdateStructureSectorRequest {
  readonly structureId: string

  readonly projectId: number

  readonly codeLibelle: CodeLibelle
}

/**
 * SectorsResourceApi - object-oriented interface
 */
export class SectorsResourceApi extends BaseAPI {
  /**
   *
   * @summary Get project sector informations
   * @param {SectorsResourceApiGetProjectSectorRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public getProjectSector(
    requestParameters: SectorsResourceApiGetProjectSectorRequest,
    options?: RawAxiosRequestConfig
  ) {
    return SectorsResourceApiFp(this.configuration)
      .getProjectSector(requestParameters.projectId, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Get structure sector informations
   * @param {SectorsResourceApiGetStructureSectorRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public getStructureSector(
    requestParameters: SectorsResourceApiGetStructureSectorRequest,
    options?: RawAxiosRequestConfig
  ) {
    return SectorsResourceApiFp(this.configuration)
      .getStructureSector(requestParameters.structureId, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Update project sector
   * @param {SectorsResourceApiUpdateProjectSectorRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public updateProjectSector(
    requestParameters: SectorsResourceApiUpdateProjectSectorRequest,
    options?: RawAxiosRequestConfig
  ) {
    return SectorsResourceApiFp(this.configuration)
      .updateProjectSector(requestParameters.projectId, requestParameters.codeLibelle, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Update structure sector
   * @param {SectorsResourceApiUpdateStructureSectorRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public updateStructureSector(
    requestParameters: SectorsResourceApiUpdateStructureSectorRequest,
    options?: RawAxiosRequestConfig
  ) {
    return SectorsResourceApiFp(this.configuration)
      .updateStructureSector(
        requestParameters.structureId,
        requestParameters.projectId,
        requestParameters.codeLibelle,
        options
      )
      .then(request => request(this.axios, this.basePath))
  }
}
